import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 346 346"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M123.313 292.97H107.5V53.03H185v23.333a7.5 7.5 0 0 0 15 0V45.53a7.5 7.5 0 0 0-7.5-7.5H7.5a7.5 7.5 0 0 0-7.5 7.5v30.833a7.5 7.5 0 0 0 15 0V53.03h77.5v239.94H76.687a7.5 7.5 0 0 0 0 15h46.626a7.5 7.5 0 0 0 0-15m215.187-49a7.5 7.5 0 0 0-7.5 7.5c0 22.883-18.617 41.5-41.5 41.5s-41.5-18.617-41.5-41.5V151.5h40.5a7.5 7.5 0 0 0 0-15H248V45.53a7.5 7.5 0 0 0-15 0v90.97h-40.5a7.5 7.5 0 0 0 0 15H233v99.97c0 31.154 25.346 56.5 56.5 56.5s56.5-25.346 56.5-56.5a7.5 7.5 0 0 0-7.5-7.5" }, null, -1)
  ])))
}
export default { render: render }